import React from "react";
import clsx from "clsx";

type MkdnLogoProps = {
    size?: "sm" | "md" | "lg" | "xl";
    className?: string;
    textClassName?: string;
};

const sizeMap = {
    sm: { icon: "size-5", text: "text-xl" },
    md: { icon: "size-6", text: "text-2xl" },
    lg: { icon: "size-8", text: "text-3xl" },
    xl: { icon: "size-10", text: "text-4xl" },
};

const MkdnLogo: React.FC<MkdnLogoProps> = ({
    size = "lg",
    className = "",
    textClassName = "",
}) => {
    const selectedSize = sizeMap[size];

    return (
        <div className={clsx("inline-flex items-center gap-2", className)}>
            <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 640 512"
                className={clsx(selectedSize.icon, "translate-y-[2px]")}
                fill="url(#myGradient)"
            >
                <defs>
                    <linearGradient id="myGradient" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#7dd3fc" />
                        <stop offset="100%" stopColor="#3b82f6" />
                    </linearGradient>
                </defs>
                <path d="M593.8 59.1H46.2C20.7 59.1 0 79.8 0 105.2v301.5c0 25.5 20.7 46.2 46.2 46.2h547.7c25.5 0 46.2-20.7 46.1-46.1V105.2c0-25.4-20.7-46.1-46.2-46.1zM338.5 360.6H277v-120l-61.5 76.9-61.5-76.9v120H92.3V151.4h61.5l61.5 76.9 61.5-76.9h61.5v209.2zm135.3 3.1L381.5 256H443V151.4h61.5V256H566z" />
            </svg>

            <span className={clsx("font-bold", selectedSize.text, textClassName)}>
                mkdn
            </span>
        </div>
    );
};

export default MkdnLogo;
